var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 40.935-13.263-10.61-.006.006A.982.982 0 0 0 16 30a.982.982 0 0 0-.731.331l-.006-.006L2 40.935V2h28v38.935zM31 0H1a1 1 0 0 0-1 1v42a1 1 0 0 0 1 1 .985.985 0 0 0 .732-.33l.005.006L16 32.266l14.263 11.41.006-.006c.182.201.439.33.731.33a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM10.87 15.991h3.515l.488-1.297L16 11.69l1.128 3.004.486 1.297h3.516l-1.851 1.426-1.126.869.45 1.348 1.012 3.038-2.432-1.784L16 20.021l-1.183.867-2.432 1.784 1.012-3.038.451-1.348-1.127-.869-1.851-1.426zM8.499 28 16 22.5l7.501 5.5-3.001-8.999 6.5-5.01h-8L16 6l-3 7.991H5l6.5 5.01L8.499 28z",
    fill: "#3285C2",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityIcon);
export default __webpack_public_path__ + "static/media/quality-icon.dcd1f7ee.svg";
export { ForwardRef as ReactComponent };